import type { GModalOrderJourneyInitialValues } from '../types';

import { useGModalContext, ModalType } from '~/presentation/ui';

export const useGModalOrderJourney = () => {
  const { onOpenModal, initialValues } = useGModalContext<ModalType.ORDER_JOURNEY>();

  const handleOpenModalOrderJourney = (data: GModalOrderJourneyInitialValues) => {
    onOpenModal(ModalType.ORDER_JOURNEY, data);
  };

  return {
    initialValues,
    handleOpenModalOrderJourney,
  };
};
